var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 9,
    viewBox: "0 0 11 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.31474 0.431856L0.1158 7.7041C0.0399525 7.83543 1.40378e-05 7.98441 3.69988e-09 8.13606C-1.40304e-05 8.28772 0.0398969 8.4367 0.11572 8.56805C0.191544 8.69939 0.300607 8.80845 0.431947 8.88428C0.563286 8.9601 0.712273 9.00001 0.863928 9H9.26113C9.41278 9.00001 9.56177 8.9601 9.69311 8.88428C9.82445 8.80845 9.93351 8.69939 10.0093 8.56805C10.0852 8.4367 10.1251 8.28772 10.1251 8.13606C10.125 7.98441 10.0851 7.83543 10.0093 7.7041L5.81077 0.431856C5.73496 0.300555 5.62592 0.191521 5.49462 0.115715C5.36331 0.0399087 5.21437 0 5.06275 0C4.91114 0 4.76219 0.0399087 4.63089 0.115715C4.49959 0.191521 4.39055 0.300555 4.31474 0.431856Z",
    fill: "#FC5656"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.11758 2.6748H5.00805C4.73838 2.6748 4.51978 2.89341 4.51978 3.16308V5.49693C4.51978 5.7666 4.73838 5.98521 5.00805 5.98521H5.11758C5.38724 5.98521 5.60585 5.7666 5.60585 5.49693V3.16308C5.60585 2.89341 5.38724 2.6748 5.11758 2.6748Z",
    fill: "#FFF7ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.06294 7.83608C5.36285 7.83608 5.60597 7.59295 5.60597 7.29304C5.60597 6.99313 5.36285 6.75 5.06294 6.75C4.76302 6.75 4.5199 6.99313 4.5199 7.29304C4.5199 7.59295 4.76302 7.83608 5.06294 7.83608Z",
    fill: "#FFF7ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorNotification);
export default __webpack_public_path__ + "static/media/error-notification.7524ee060a6f090e4ff634c680621f88.svg";
export { ForwardRef as ReactComponent };